module.exports = __webpack_public_path__ + "static/media/Screenshot_3-thumb.4ba83a48.png";